import {
  determineMapServicePermission,
  determineZenrinPermission,
} from "@/utils/determineMapServicePermission";
import { useEffect, useState } from "react";

const getPermissionFromLocalStorage = (): boolean | null => {
  try {
    const appId = localStorage.getItem("mapServiceAppId");
    const trialStartDate = localStorage.getItem("mapServiceTrialStartDate");
    const trialEndDate = localStorage.getItem("mapServiceTrialEndDate");
    const contractStartDate = localStorage.getItem(
      "mapServiceContractStartDate"
    );
    const contractEndDate = localStorage.getItem("mapServiceContractEndDate");
    const zenrinContractStartDate = localStorage.getItem(
      "mapZenrinContractStartDate"
    );
    const zenrinContractEndDate = localStorage.getItem(
      "mapZenrinContractEndDate"
    );
    const zenrinTrialStartDate = localStorage.getItem(
      "mapZenrinTrialStartDate"
    );
    const zenrinTrialEndDate = localStorage.getItem("mapZenrinTrialEndDate");

    const geospacePermission = determineMapServicePermission({
      appId: appId ?? null,
      contractStartDate: contractStartDate ?? null,
      contractEndDate: contractEndDate ?? null,
      trialStartDate: trialStartDate ?? null,
      trialEndDate: trialEndDate ?? null,
    });
    const hasZenrinPermission = determineZenrinPermission({
      contractStartDate: zenrinContractStartDate ?? null,
      contractEndDate: zenrinContractEndDate ?? null,
      trialStartDate: zenrinTrialStartDate ?? null,
      trialEndDate: zenrinTrialEndDate ?? null,
    });

    return geospacePermission || hasZenrinPermission;
  } catch {
    // localStorage が参照できない環境（SSR等）では不明扱い
    return null;
  }
};

export const useMapServicePermission = (): [boolean | null, boolean] => {
  const [hasPermission, setHasPermission] = useState<boolean | null>(() =>
    getPermissionFromLocalStorage()
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const permission = getPermissionFromLocalStorage();
    setHasPermission(permission);
    setLoading(false);
  }, []);

  return [hasPermission, loading];
};
